const loanPayout = [
  { label: 'schnellstmöglich', value: 'AS_SOON_AS_POSSIBLE' },
  { label: 'selbst Datum auswählen', value: 'OWN_DATE' }
]

export default loanPayout
